import { INDEXED_SEARCH_PATH } from 'constants/main';
import categoryNameConstruct from 'utils/categoryNameConstruct';
import { TemplateCategoryResponseModel } from './types';

export default async function getTemplateCategory(
  category: string,
  subCategory: string,
  headers?: any,
): Promise<TemplateCategoryResponseModel> {
  const { finalCategory } = categoryNameConstruct(category, subCategory);

  const baseUrl = `${process.env.REACT_APP_API_URL}/content-categories/template/${finalCategory}`;
  const url =
    subCategory && category !== INDEXED_SEARCH_PATH ? `${baseUrl}/${subCategory}` : baseUrl;

  const res = await fetch(url, {
    headers,
  });

  if (!res.ok) {
    throw new Error(`Status error fetching ${url}: ${res.status}`);
  }

  return res.json();
}
